// Angular Imports
import { NgModule } from '@angular/core';

// This Module's Components
import { LoginComponent } from './login.component';
import { CommonModule } from '@angular/common';
import { LayoutService } from '../@http-service/layout.service';
import { LoginRoutingModule } from './login.routing'
import { CustomClarityModule } from '../custom.clarity.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ValidationMessageComponent } from '../validation-message/validation.message';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { TermsComponent } from './terms/terms.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { CustomerSharedModule } from 'src/@shared/customer.shared.module';
import { ToastrModule } from 'ngx-toastr';

@NgModule({
    imports: [
        CommonModule,
        LoginRoutingModule,
        CustomerSharedModule,
        ToastrModule.forRoot(),
    ],
    declarations: [
        LoginComponent,
        HeaderComponent,
        FooterComponent,
        TermsComponent,
        ForgotPasswordComponent
    ],
    exports: [
        HeaderComponent,
        FooterComponent,
    ],
    providers: [
        LayoutService
    ]
})
export class LoginModule {

}
